import { observer } from 'mobx-react';
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContextProvider } from '../../../AppLoader';
import { ThemedText } from '../../../ThemedComponents';
import { ResendVerificationCode } from '../../ResendVerificationCode';
import { CodeStepCard } from '../CodeStepCard';
import { VerificationState } from '../../VerifyButton';

/**
 * redesigned email "confirm code" step (wix-2025). A thin wrapper that
 * plugs the `confirmEmail` store into the shared `CodeStepCard`.
 */
export const ConfirmationCodeStepRedesign: React.FC = observer(() => {
  const { t } = useTranslation();
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { confirmEmail: store },
      },
    },
  } = useContext(AppContextProvider);

  useEffect(() => {
    store.resendSuccessfullyIndication = true;
  }, []);

  const subtitle = (
    <>
      {t('confirmEmailModalSecondStep.confirmationCode.content')}{' '}
      <ThemedText weight="bold" dir="ltr">
        {store.email}
      </ThemedText>
    </>
  );

  return (
    <CodeStepCard
      title={store.titleSecondStep}
      subtitle={subtitle}
      onBack={store.onBackToConfirmEmail}
      // verifyConfirmationCode is `action` (not action.bound), so wrap to keep `this`.
      onVerify={() => store.verifyConfirmationCode()}
      verifyDisabled={!store.code.isValid}
      showLoader={store.verificationState !== VerificationState.Unverified}
      field={store.code}
      resend={
        <ResendVerificationCode
          sendConfirmationCode={store.sendConfirmationCode}
          resendSuccessfullyIndication={store.resendSuccessfullyIndication}
          resendThrottleTimerValue={store.resendThrottleTimerValue}
          resendButtonSize="small"
          resendIndicationTranslationKey="code.resend.indication"
          showAsButton
          variant="themed"
        />
      }
    />
  );
});
